import './styles/dashboard_mobile.scss'

// Horizontally-scrollable unit chips. `vehicles` is the already filtered+sorted list from
// index.jsx. onSelect(vehicle) selects + recenters + opens the detail. The container class
// is overridable so the same chips can be the mobile bottom strip or the desktop top bar.
export const UnitStrip = ({ vehicles, selectedUnitID, onSelect, className = 'rz-unitstrip' }) => {
  if (!vehicles || !vehicles.length) return null
  return (
    <div className={className}>
      {vehicles.map(v => (
        <button key={v.unit_id}
          className={`rz-unitchip${v.unit_id.startsWith(selectedUnitID) && selectedUnitID ? ' sel' : ''}`}
          onClick={() => onSelect(v)}>
          {/* Dot = Live: green when the unit is online (reporting status), red otherwise.
              `active` is present on every unit (selected or not), so the dot no longer flips
              green only on selection, and it's NOT tied to radar/lane/object health. */}
          <span className={`rz-dot ${v.active ? 'ok' : 'err'}`} />
          <span className="rz-chip-name">{v.vehicle_name || v.serial_number}</span>
          {/* Armed only when automated alerts are on (pendant/tablet); otherwise Idle.
              `system_enabled` is the real arm state — `active` (online) is not. */}
          <span className="rz-chip-sub">{v.system_enabled ? 'Armed' : 'Idle'}</span>
        </button>
      ))}
    </div>
  )
}
export default UnitStrip
